import styled from 'styled-components';
import { typography } from '../ThemeProvider/ThemeProvider';
import { Link } from '../Link/Link';

export const MenuLink = styled(Link)`
  ${typography('cell')};
  color: ${({ theme }) => theme.colorsNew.gray.black};
`;
